import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import UserBadge from "components/materials/UserBadge";
import { formatUserName } from "utils/UserUtils";
import { formatDateTime } from "utils/DateUtils";
import classes from "./classes.module.scss";
import { useProjectContext } from "components/pages/FeaturedProjects/contexts/Project";
import FilmCrewBadge from "components/materials/FilmCrewBadge";

type IProps = {
	comment: CommentResponseResource;
};

function FilmReaderInfo(props: IProps) {
	return (
		<div className={classes["root"]}>
			<UserBadge user={props.comment.author} className={classes["avatar"]} />
			<div className={classes["publication"]}>
				<div className={classes["by"]}>
					<Typography type="h5" weight="bold">
						{formatUserName(props.comment.author)}
					</Typography>
				</div>
				{props.comment.createdAt && (
					<div className={classes["at"]}>
						<Typography type="p" weight="regular" size="small" color="inherit">
							{formatDateTime(props.comment.createdAt)}
						</Typography>
					</div>
				)}
			</div>
		</div>
	);
}

function FilmCrewInfo(props: IProps) {
	const { project } = useProjectContext();

	return (
		<div className={classes["root"]}>
			<div className={classes["avatar"]}>
				<FilmCrewBadge project={project} user={props.comment.author} className={classes["avatar"]} />
			</div>
			<div className={classes["publication"]}>
				<div className={classes["by"]}>
					<Typography type="h5" weight="bold">
						{`${I18n.trslt(I18n.asset.common.crew)} ${project.title}`}
					</Typography>
				</div>
				{props.comment.createdAt && (
					<div className={classes["at"]}>
						<Typography type="p" weight="regular" size="small" color="inherit">
							{formatDateTime(props.comment.createdAt)}
						</Typography>
					</div>
				)}
			</div>
		</div>
	);
}

export default function CommentAuthorInfo(props: IProps) {
	const { project } = useProjectContext();

	const isPublishedByFilmCrew = props.comment.author.id === project.author.id;

	if (isPublishedByFilmCrew) {
		return <FilmCrewInfo comment={props.comment} />;
	} else {
		return <FilmReaderInfo comment={props.comment} />;
	}
}
